import { FC } from 'react';
import { ConfirmButton, ConfirmContent, ConfirmText, ConfirmWrapper, DeclineButton } from './styles';
import { FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { API, Endpoints } from '@brg/api';
import { IConfirmCoverDeleteModalProps } from './types';


export const ConfirmDeleteCoverModal: FC<IConfirmCoverDeleteModalProps> = ({teamId, teamBGLang, onDelete, handleClose, tabIndex, isTabImg }) => {
    const { t } = useTranslation();

    const handleDelete = () => {
        if (teamId) {
          API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Team/DeleteTitleImage')
          .post()
          .body({
              teamId: teamId,
              localization: !!teamBGLang ? 'en' : 'ru'
          })
          .send()
          .then((r) => r.json())
          .then((r) => {
            onDelete();
            handleClose();
          })
          .catch((e) => console.error(e))
        }
      };

    const handleTabDelete = () => {
          API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Team/DeleteTabTitleImage')
          .post()
          .body({
              teamId: teamId,
              localization: !!teamBGLang ? 'en' : 'ru',
              tabIdx: tabIndex
          })
          .send()
          .then((r) => r.json())
          .then((r) => {
            onDelete();
            handleClose();
          })
          .catch((e) => console.error(e))
      };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction='column'>
                <ConfirmText>{t('project_edit.modal.confirmDeleteCover.text')}</ConfirmText>
                <FlexBox gx={24} gxMobile={'0'}  gyMobile={16} direction='row' directionMobile='column' offsetTop={24} justify='center'>
                    <ConfirmButton fixedSize onClick={isTabImg ? handleTabDelete : handleDelete}>
                        {t('project_edit.modal.confirmDeleteCover.buttons.hollow')}
                    </ConfirmButton>
                    <DeclineButton fixedSize onClick={handleClose}>
                        {t('project_edit.modal.confirmDeleteCover.buttons.filled')}
                    </DeclineButton>
                   
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    )
}import { FC } from 'react';
import { ConfirmButton, ConfirmContent, ConfirmText, ConfirmWrapper, DeclineButton } from './styles';
import { FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { API, Endpoints } from '@brg/api';
import { IConfirmCoverDeleteModalProps } from './types';


export const ConfirmDeleteCoverModal: FC<IConfirmCoverDeleteModalProps> = ({teamId, teamBGLang, onDelete, handleClose, tabIndex, isTabImg }) => {
    const { t } = useTranslation();

    const handleDelete = () => {
        if (teamId) {
          API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Team/DeleteTitleImage')
          .post()
          .body({
              teamId: teamId,
              localization: !!teamBGLang ? 'en' : 'ru'
          })
          .send()
          .then((r) => r.json())
          .then((r) => {
            onDelete();
            handleClose();
          })
          .catch((e) => console.error(e))
        }
      };

    const handleTabDelete = () => {
          API.request()
          .endpoint(Endpoints.geograffee)
          .url('/api/Team/DeleteTabTitleImage')
          .post()
          .body({
              teamId: teamId,
              localization: !!teamBGLang ? 'en' : 'ru',
              tabIdx: tabIndex
          })
          .send()
          .then((r) => r.json())
          .then((r) => {
            onDelete();
            handleClose();
          })
          .catch((e) => console.error(e))
      };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction='column'>
                <ConfirmText>{t('project_edit.modal.confirmDeleteCover.text')}</ConfirmText>
                <FlexBox gx={24} gxMobile={'0'}  gyMobile={16} direction='row' directionMobile='column' offsetTop={24} justify='center'>
                    <ConfirmButton fixedSize onClick={isTabImg ? handleTabDelete : handleDelete}>
                        {t('project_edit.modal.confirmDeleteCover.buttons.hollow')}
                    </ConfirmButton>
                    <DeclineButton fixedSize onClick={handleClose}>
                        {t('project_edit.modal.confirmDeleteCover.buttons.filled')}
                    </DeclineButton>
                   
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    )
}